import { render, staticRenderFns } from "./CallArea.vue?vue&type=template&id=71ff991b"
import script from "./CallArea.vue?vue&type=script&lang=js"
export * from "./CallArea.vue?vue&type=script&lang=js"
import style0 from "./CallArea.vue?vue&type=style&index=0&id=71ff991b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports